import Setting from "pwa/db/Setting";

const DEFAULT_VALUE = ["__SB__"];
const ERROR_VALUE = DEFAULT_VALUE;

const offlineSyncSelectedSellers = new Setting(
  "offline-sync-selected-sellers",
  DEFAULT_VALUE,
  ERROR_VALUE,
  (value) => JSON.parse(value) as string[],
  (value) => JSON.stringify(value)
);

export default offlineSyncSelectedSellers;
